// extracted by mini-css-extract-plugin
module.exports = {"places":"places-module--places--2R7dZ","typography":"places-module--typography--32buh","cardShadow":"places-module--card-shadow--149sf"};